import * as prismatic from "./exports";

export * from "./exports";
export default prismatic;
